<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlDetailItem',
})
</script>
<template>
  <Timeline.Item v-bind="$attrs">
    <div :class="bem('title')">{{ title }}</div>
    <slot />
  </Timeline.Item>
</template>

<script lang="ts" setup name="TlDetailItem">
import { createNamespace } from '@bd/vue3-utils'
import { Timeline } from 'ant-design-vue'

defineProps<{
  title?: string
}>()
const [_, bem] = createNamespace('TlDetailItem')
</script>

<style lang="less">
.tl-detail-item {
  &__title {
    margin-bottom: @margin-xs;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }

  &__field {
    margin-bottom: @margin-xs;
  }

  &__label {
    color: @text-color-secondary;
    font-size: 14px;
    line-height: 20px;
  }

  &__content {
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
